// extracted by mini-css-extract-plugin
export default {"contentContainer":"StyledDialogCatalog_contentContainer__Y-h3l","iconContainer":"StyledDialogCatalog_iconContainer__xZGfl","closeIcon":"StyledDialogCatalog_closeIcon__g5AH0"};